// extracted by mini-css-extract-plugin
export default {"navBar":"Navbar_navBar__-E2gc","navText":"Navbar_navText__+38jj","dappModal":"Navbar_dappModal__DCyi4"};